import { Link } from "react-router-dom";
import { ArrowRight, Instagram, Facebook } from "lucide-react";
import { toast } from "sonner";
import { useEffect, useState } from "react";
import { apiFetch, resolveImageUrl } from "../lib/api";

export default function Footer() {
  const [cats, setCats] = useState([]);
  const [settings, setSettings] = useState({});
  useEffect(() => {
    apiFetch("/categories").then(setCats).catch(() => {});
    apiFetch("/site-settings").then(setSettings).catch(() => {});
  }, []);
  return (
    <footer>
      <div className="footer-brand">
        <Link className="logo light-logo" to="/">
          {settings.logo_url
            ? <img src={resolveImageUrl(settings.logo_url)} alt={settings.brand_name || "GMK"} className="logo-img"/>
            : <span className="logo-mark" aria-hidden>✦</span>}
          <span>GMK <b>Handicrafts</b><small>EMPORIUM</small></span>
        </Link>
        <p>Authentic Kashmiri craftsmanship<br/>for a life well lived.</p>
      </div>
      <div>
        <b>Explore</b>
        <Link to="/shawls">All shawls</Link>
        {cats.map((c) => <Link key={c.id} to={`/shawls/${c.slug}`}>{c.name}</Link>)}
        <Link to="/about">About us</Link>
        <Link to="/contact">Contact</Link>
      </div>
      <div>
        <b>Customer</b>
        <Link to="/account">My account</Link>
        <Link to="/account?tab=orders">Orders</Link>
        <Link to="/account?tab=wishlist">Wishlist</Link>
        <Link to="/pages/shipping">Shipping</Link>
        <Link to="/pages/returns">Returns</Link>
        <Link to="/pages/privacy">Privacy</Link>
        <Link to="/pages/terms">Terms &amp; conditions</Link>
      </div>
      <div>
        <b>Stay close</b>
        <p>Notes on craft, culture and the collection.</p>
        <form onSubmit={(e) => { e.preventDefault(); toast.success("You're on the list"); }}>
          <input placeholder="Email address" data-testid="newsletter-email" aria-label="Email address"/>
          <button data-testid="newsletter-submit" aria-label="Subscribe"><ArrowRight size={17}/></button>
        </form>
        <div className="social-row">
          {settings.instagram && <a href={settings.instagram} target="_blank" rel="noreferrer" aria-label="Instagram"><Instagram size={17}/></a>}
          {settings.facebook && <a href={settings.facebook} target="_blank" rel="noreferrer" aria-label="Facebook"><Facebook size={17}/></a>}
        </div>
      </div>
      <div className="copyright">
        © {new Date().getFullYear()} GMK Handicrafts Emporium <span>·</span> Crafted in Kashmir
      </div>
    </footer>
  );
}
